<vehicle-type-switch-component [selectedValue]="selectedVehicleType" (selectedValueChange)="selectedVehicleTypeValueChange($event)"></vehicle-type-switch-component>
<div class="service-frequency">
  <div class="filters" *ngIf="data?.filterOptions">
    <div class="filter-field">
      <mat-form-field appearance="fill">
        <mat-label>Container Type</mat-label>
        <mat-select multiple [(ngModel)]="selectedContainerTypes" (ngModelChange)="onFilterChange()">
          <mat-option *ngFor="let t of data.filterOptions.containerTypes" [value]="t">{{ t }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="filter-field location-type-hidden">
      <mat-form-field appearance="fill">
        <mat-label>Location Type</mat-label>
        <mat-select multiple [(ngModel)]="selectedLocationTypes" (ngModelChange)="onFilterChange()">
          <mat-option *ngFor="let lt of data.filterOptions.locationTypes" [value]="lt">{{ lt }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="filter-field">
      <mat-form-field appearance="fill">
        <mat-label>Depot</mat-label>
        <mat-select multiple [(ngModel)]="selectedDepotIds" (ngModelChange)="onFilterChange()">
          <mat-option *ngFor="let d of data.filterOptions.depots" [value]="d.id">{{ d.name }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="kpi">
      <div class="kpi-value">{{ averageDaysOnSite }}</div>
      <div class="kpi-label">AVERAGE DAYS ON SITE</div>
    </div>
  </div>

  <div class="layout">
    <div class="left" [class.offset-for-actions]="data?.rows?.length">
      <mat-card>
        <mat-card-title>Slow Moving Fleet Summary</mat-card-title>
        <div class="chart chart--pie">
          <canvas baseChart
                  [type]="'pie'"
                  [data]="pieData"
                  [options]="pieOptions"
                  [plugins]="piePlugins">
          </canvas>
        </div>
      </mat-card>

      <mat-card>
        <mat-card-title>Slow Moving Fleet Trend</mat-card-title>
        <div class="chart chart--line">
          <canvas baseChart
                  [type]="'line'"
                  [data]="lineData"
                  [options]="lineOptions"
                  [plugins]="linePlugins">
          </canvas>
        </div>
      </mat-card>
    </div>

    <div class="right">
      <div class="table-actions" *ngIf="data?.rows?.length">
        <button (click)="exportServiceFrequency()" class="btn btn-white btn-sm">
          Export Data
          <span class="svg-icon svg-icon-xs ms-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><title>Export data</title><polyline points="268 112 412 256 268 400" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"/><line x1="392" y1="256" x2="100" y2="256" style="fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px"/></svg>
          </span>
        </button>
      </div>
      <mat-card>
        <div class="table-wrap" *ngIf="data?.rows?.length">
          <table mat-table [dataSource]="data.rows" class="mat-elevation-z1">

            <ng-container matColumnDef="containerId">
              <th mat-header-cell *matHeaderCellDef class="sortable" (click)="toggleSort('containerId')">
                Container
                <span class="sort-indicator" [ngClass]="getSortDirection('containerId')"></span>
              </th>
              <td mat-cell *matCellDef="let r">{{ r.containerId }}</td>
            </ng-container>

            <ng-container matColumnDef="assetType">
              <th mat-header-cell *matHeaderCellDef class="sortable" (click)="toggleSort('assetType')">
                Type
                <span class="sort-indicator" [ngClass]="getSortDirection('assetType')"></span>
              </th>
              <td mat-cell *matCellDef="let r">{{ r.assetType }}</td>
            </ng-container>

            <ng-container matColumnDef="depotName">
              <th mat-header-cell *matHeaderCellDef class="sortable" (click)="toggleSort('depotName')">
                Depot
                <span class="sort-indicator" [ngClass]="getSortDirection('depotName')"></span>
              </th>
              <td mat-cell *matCellDef="let r">{{ r.depotName }}</td>
            </ng-container>

            <ng-container matColumnDef="locationName">
              <th mat-header-cell *matHeaderCellDef class="sortable" (click)="toggleSort('locationName')">
                Location
                <span class="sort-indicator" [ngClass]="getSortDirection('locationName')"></span>
              </th>
              <td mat-cell *matCellDef="let r">{{ r.locationName }}</td>
            </ng-container>

            <ng-container matColumnDef="from">
              <th mat-header-cell *matHeaderCellDef class="sortable" (click)="toggleSort('from')">
                From
                <span class="sort-indicator" [ngClass]="getSortDirection('from')"></span>
              </th>
              <td mat-cell *matCellDef="let r">{{ r.from | date:'dd/MM/yy' }}</td>
            </ng-container>

            <ng-container matColumnDef="to">
              <th mat-header-cell *matHeaderCellDef class="sortable" (click)="toggleSort('to')">
                To
                <span class="sort-indicator" [ngClass]="getSortDirection('to')"></span>
              </th>
              <td mat-cell *matCellDef="let r">{{ r.to | date:'dd/MM/yy' }}</td>
            </ng-container>

            <ng-container matColumnDef="info">
              <th mat-header-cell *matHeaderCellDef class="sortable" (click)="toggleSort('info')">
                Info
                <span class="sort-indicator" [ngClass]="getSortDirection('info')"></span>
              </th>
              <td mat-cell *matCellDef="let r">{{ r.info }}</td>
            </ng-container>

            <ng-container matColumnDef="days">
              <th mat-header-cell *matHeaderCellDef class="sortable" (click)="toggleSort('days')">
                Days
                <span class="sort-indicator" [ngClass]="getSortDirection('days')"></span>
              </th>
              <td mat-cell *matCellDef="let r">
                <span class="days-chip" [ngClass]="getDaysClass(r.days)">{{ r.days }}</span>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>
        </div>

        <div *ngIf="!data?.rows?.length" class="empty">
          No results.
        </div>

      </mat-card>
    </div>
  </div>
</div>
